<template>
  <div class="homePage" :style="'height:' + height + 'px'">
    <Header :index="selectIndex" @change="menuChange" :list="menuList"></Header>
    <div class="industry_container" :style="'height:' + (height - 52) + 'px'">
      <Menu :list="selectList" :style="'height:' + (height - 52) + 'px'"></Menu>
      <div class="rightContainer">
        <router-view></router-view>
      </div>
    </div>

    <el-dialog title="法人认证" v-model="dialogVisibleAuth" class="auth-dialog" width="50%">
      <div class="auth-dialog-main">
        <div class="auth-dialog-main-panel">
          <div class="tit">认证二维码</div>
          <div class="code"><img src="../assets/images/code.jpg" alt="" style="width:100%;"></div>
          <div class="auth-other-opt">
            <div><el-checkbox v-model="isAuth" size="small">我已进行法人认证，以后不用通知</el-checkbox></div>
            <div class="down-btn"><a :href="codeurl" download="code">下载到本地</a></div>
          </div>
        </div>
      </div>
      <template #footer>
        <div class="auth-dialog-footer">
          <div class="tips">注：及时进行法人认证，否则影响交易(可在系统管理-设置-基本信息查看)</div>
          <div class="btn">
            <el-button @click="dialogVisibleAuth=false">取 消</el-button>
            <el-button type="primary" @click="confirmAuth">确 定</el-button>
          </div>
        </div>
      </template>
		</el-dialog>
  </div>
</template>
<script>
import { ref, getCurrentInstance, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from 'vue-i18n'
import Header from "../components/topHeader/topHeader.vue";
import Menu from "../components/leftMenu/leftMenu.vue";

export default {
  name: "homePage",
  components: { Header, Menu },
  setup() {
    const { proxy } = getCurrentInstance();
    const { locale } = useI18n()
    const lang = ref(locale.value)
    const changeLang = e=>{
      lang.value = e
    }
    const height = ref(document.documentElement.clientHeight);
    // 监听浏览器尺寸变化
    onMounted(() => {
      window.addEventListener("resize", () => {
        // 监听页面尺寸变化
        // console.log(document.documentElement.clientHeight);
        height.value = document.documentElement.clientHeight;
      });
      
    });
    function createAhtml(url){
      let dom = document.createElement('a');
      dom.setAttribute('href', url.href);
      dom.setAttribute('target','_blank');
      document.body.appendChild(dom);
      dom.click();
      document.body.removeChild(dom)
    }
    function getEntpInfo(){
      //let newWindow=proxy.tool.openWindow('','_blank')
      proxy.$request({
        url:"SYSTEM_W_ENTPAUTH_GETDETAIL",
        method: "post",
      }).then((res) => {
        if(res.data.code=="000"){
          let result=res.data.result;
          if(result){
            if(result.authStatusType=='0'){//信息提交成功，平台工作人员将在2个工作日内审核
              let url=router.resolve({
                path: "settleEdit",
                query: { authStatusType:result.authStatusType},
              })
              createAhtml(url)
              //proxy.tool.openWindow(url.href,'_blank')
              //newWindow.location=url.href
            }else if(result.authStatusType=='4'){
              console.log('法人认证');
              if(localStorage.getItem("isConfirmAuth")=='1'){
                menuInit(0);
              }else{
                dialogVisibleAuth.value=true;
              }
            }else if(result.authStatusType=='5'){//通过
              menuInit(0);
            }else{
              const url=router.resolve({
                path: "settleDetail",
              })
              createAhtml(url)
              //proxy.tool.openWindow(url.href,'_blank');
              //newWindow.location=url.href
            }
          }else{
            let url=router.resolve({
              path: "settle",
            })
            createAhtml(url)
            //proxy.tool.openWindow(url.href,'_blank');
            //newWindow.location=url.href
            
          }
        }
      }).catch((err) => {
        console.log(err)
      });
    }
    let isAuth=ref(false);
    let dialogVisibleAuth=ref(false);
    function confirmAuth(){
      if(isAuth.value){
        proxy.$request({
          method: "post",
          url: "SYSTEM_W_ENTPAUTH_CONFIRMWXAUTH",
          data: {},
        }).then((res) => {
          if (res.data.code == "000") {
            dialogVisibleAuth.value=false;
            menuInit(0);
          }
        });
      }else{
        localStorage.setItem("isConfirmAuth",'1')
        dialogVisibleAuth.value=false;
        menuInit(0);
      }
    }
    const menuList = ref([]);
    const selectList = ref([]);
    const router = useRouter();
    const route = useRoute()
    const selectIndex = ref(0);
    const menuType = ref('')
    const menuChange = (e) => {
      // selectIndex.value = e.index;
      menuType.value = e.type
      console.log(e)
      if(e.type=="entp_digital_shop"){
        console.log(router)
        getEntpInfo()
      }else{
        menuInit(0)
      }
    };
    const menuInit = (type) => {
      //type为0则是默认处理,为1则为回显
      //顶部菜单初始化
      proxy
        .$request({
          url: "AUTH_LIST",
          data: {type:route.query.ltype},
        })
        .then((res) => {
          selectList.value = res.data.result;
          if(type===0){
            if (selectList.value[0].children[0].children[0].href) {
              console.log(selectList.value[0].children[0].children[0].href)
              router.push(selectList.value[0].children[0].children[0].href);
            } else {
              proxy.$message({
                message: "暂未配置地址",
                center: true,
                type: "error",
                duration: 2000,
              });
            }
          }
          
          // menuList.value = res.data.result.find(e=>e.id==id)?.children
        })
        .catch((err) => {
          console.log(err);
        });
    };

    
    const topMenuInit = ()=>{
      //顶部菜单初始化
        proxy
        .$request({
          url: 'MENUSERVICE_LIST',
          data: {
                type:'admin_entp'
            },
        })
        .then((res) => {
          menuList.value = res.data.result
          if(route.path=='/'){
            //刚登录不做处理直接进默认
            menuType.value = menuList.value[0].type
            menuInit(0)
          }else{
            //回显菜单
            let mrIndex = menuList.value.findIndex(e=>e.name==route.name.list[0])
            if(mrIndex==-1)mrIndex=0
            selectIndex.value = mrIndex
            menuType.value = menuList.value[mrIndex].type
            menuInit(1)
          }
          //默认选中
          
        })
        .catch((err) => {
            console.log(err)
        });
    }
    if(route.query.ltype){
      menuInit()
    }
    // menuInit();
    return {
      height,
      menuChange,
      selectIndex,
      menuList,
      selectList,
      dialogVisibleAuth,
      confirmAuth,
      isAuth,
      changeLang,
      lang
    };
  },
};
</script>
<style scoped lang="less">
.homePage {
  overflow: hidden;
  .industry_container {
    display: flex;
    border-top: 1px solid #f7f8fa;
  }
  .rightContainer {
    flex-grow: 1;
    width: calc(100% - 240px);
    background-color: #f7f8fa;
  }
  :deep(.auth-dialog){
    .auth-dialog-main{
      width: 100%;
      display: flex;
      justify-content: center;
      .auth-dialog-main-panel{
        width: 320px;
      }
    }
    .auth-other-opt{
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .down-btn{
        font-size: 12px;
        a{
          color: #3e7fff;
        }
      }
    }
    .auth-dialog-footer{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .tips{
        width: 70%;
        font-size: 12px;
        color: #c7c7c7;
        text-align: left;
        font-family: PingFangSC-Regular;
      }
    }
  }
}
</style>
